// extracted by mini-css-extract-plugin
module.exports = {"container":"Presence_container__oQyIS","avatar":"Presence_avatar__1jdRz","animate":"Presence_animate__T0vZM","enter":"Presence_enter__1mcXJ"};